import { formatDbEventDateYmd } from '../../utils/eventDbDateTime';

const UNDATED_DATE_LABEL = /^(tbd|n\/a|na|null|undefined|-|–|—)$/i;

export type TicketEventDateFilterInput = {
  eventDateRaw?: string | null;
  eventTimeZone?: string | null;
  e_date_time_zone?: string | null;
  date?: string | null;
};

/** Calendar day shown for a ticket, or null when the row is N/A / Date TBD. */
export function eventDateYmdForTicketFilter(ticket: TicketEventDateFilterInput): string | null {
  const displayed = String(ticket.date || '').trim();
  if (!displayed || UNDATED_DATE_LABEL.test(displayed)) return null;

  const ymd = formatDbEventDateYmd({
    e_date: ticket.eventDateRaw,
    e_time_zone: ticket.eventTimeZone,
    e_date_time_zone: ticket.e_date_time_zone,
  });
  return ymd || null;
}

export function ticketMatchesEventDateRange(
  ticket: TicketEventDateFilterInput,
  fromYmd: string,
  toYmd: string,
): boolean {
  const ymd = eventDateYmdForTicketFilter(ticket);
  if (!ymd) return false;
  return ymd >= fromYmd && ymd <= toYmd;
}

/** Local calendar day. Date-only strings stay on that day instead of shifting through UTC. */
export function parseFilterCalendarDate(value: string): Date | null {
  const match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}

export function toLocalDateYmd(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
